<div class="list-page">
  <app-asiakas-otsikko otsikko="Käyttäjät" paluuUrl="/asiakkaat" [asiakas]="asiakas()"></app-asiakas-otsikko>

  <div style="display: flex; justify-content: flex-end; flex-flow: row; align-items: center; margin-bottom: 10px">
    <app-primary-button (click)="lisaaKayttaja()" actionId="Avattu muokkausnäkymä: Lisää uusi käyttäjä" additionalClass="mat-elevation-z4" matIcon="add"> Lisää käyttäjä </app-primary-button>
  </div>

  <div>
    <div style="position: relative">
      <mat-table matSort [dataSource]="kayttajatDataSource" [matSortDisableClear]="true" style="min-height: 94px">
        <ng-container matColumnDef="moniyritystuki">
          <mat-header-cell *matHeaderCellDef style="flex: 0 0 40px"></mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 40px">
            @if (row.moniyritystukiAvain) {
              <mat-icon matTooltip="Moniyritystuki: käyttäjä voi vaihtaa yritystä Lemonaidissa" style="font-size: 20px; width: 20px; height: 20px">switch_account</mat-icon>
            }
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="etunimi">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Etunimi </mat-header-cell>
          <mat-cell *matCellDef="let row"> {{ row.etunimi }} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="sukunimi">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Sukunimi </mat-header-cell>
          <mat-cell *matCellDef="let row"> {{ row.sukunimi ? row.sukunimi : '&nbsp;' }} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="email">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Sähköposti </mat-header-cell>
          <mat-cell *matCellDef="let row"> {{ row.email ? row.email : '&nbsp;' }} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="aktiivinen">
          <mat-header-cell *matHeaderCellDef> Aktiivinen </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <mat-checkbox [checked]="row.aktiivinen" [disabled]="true"></mat-checkbox>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="kayttajatNaytettavatKolumnit"></mat-header-row>
        <mat-row (click)="muokkaaKayttajaa(row)" *matRowDef="let row; columns: kayttajatNaytettavatKolumnit"></mat-row>
      </mat-table>
      @if (!kayttajatLataa && kayttajatDataSource?.filteredData?.length == 0) {
        <div class="table-ladataan" style="position: absolute; top: 0px; width: 100%; height: 100%; display: flex; justify-items: center; align-items: center">
          <div style="width: 100%; padding-top: 40px; text-align: center">Yhtään käyttäjää ei löytynyt.</div>
        </div>
      }
      <div lemon-loading [show]="kayttajatLataa"></div>
    </div>
  </div>
</div>
